export const DoctorProfileCard = {
  flow: 'y',
  gap: 'A',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  width: '100%',

  DoctorHeader: {
    flow: 'x',
    gap: 'Z',
    align: 'flex-start flex-start',

    DoctorAvatar: {
      width: 'D',
      height: 'D',
      round: 'D',
      background: 'teal.15',
      flexShrink: '0',
      flow: 'x',
      align: 'center center',
      Initials: {
        text: (el, s) => {
          const parts = (s.doctorName || '').split(' ')
          return parts.map(p => p.charAt(0)).join('').toUpperCase().slice(0, 2)
        },
        fontSize: 'B',
        fontWeight: '700',
        color: 'teal'
      }
    },

    DoctorInfo: {
      flow: 'y',
      gap: 'W',
      flex: '1',
      minWidth: '0',

      DoctorName: {
        text: (el, s) => s.doctorName,
        fontSize: 'A',
        fontWeight: '700',
        color: 'inkText'
      },

      DoctorSpecialties: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        children: (el, s) => (s.specialties || []).map(sp => ({ label: sp })),
        childrenAs: 'state',
        childProps: {
          text: (el, s) => s.label,
          fontSize: 'Y',
          padding: 'X Y',
          round: 'C',
          background: 'teal.1',
          color: 'teal',
          fontWeight: '500'
        }
      },

      DoctorRating: {
        flow: 'x',
        gap: 'W',
        align: 'center flex-start',
        marginTop: 'W',
        RatingStar: { extends: 'Icon', icon: 'star', width: 'Z', height: 'Z', color: 'amber' },
        RatingNum: { text: (el, s) => String(s.rating || '0'), fontSize: 'Z', fontWeight: '700', color: 'inkText' },
        ReviewCount: { text: (el, s) => '(' + (s.reviewCount || 0) + ')', fontSize: 'Y', color: 'inkMuted' }
      }
    }
  },

  DoctorClinics: {
    flow: 'y',
    gap: 'Z',
    marginTop: 'Z',
    ClinicsLabel: { text: '{{ availableAtClinics | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 'W' },

    ClinicEntries: {
      flow: 'y',
      gap: 'Y',
      children: (el, s) => s.clinics || [],
      childrenAs: 'state',
      childProps: {
        flow: 'y',
        gap: 'Y',
        padding: 'Z',
        round: 'Z',
        background: 'inkSurface',
        border: '1px solid inkBorder',

        ClinicRow: {
          flow: 'x',
          align: 'center space-between',
          gap: 'Z',

          ClinicInfo: {
            flow: 'y',
            gap: 'W',
            flex: '1',
            minWidth: '0',
            ClinicName: { text: (el, s) => s.clinicName, fontSize: 'Z', fontWeight: '600', color: 'inkText' },
            ClinicTimes: { text: (el, s) => (s.availableTimes || []).slice(0, 3).join(', '), fontSize: 'Y', color: 'inkMuted' }
          },

          BookClinicBtn: {
            extends: 'Button',
            text: '{{ bookAtClinic | polyglot }}',
            background: '#0D1117',
            color: '#FFFFFF',
            fontWeight: '600',
            padding: 'Y Z',
            round: 'Z',
            fontSize: 'Y',
            cursor: 'pointer',
            border: 'none',
            flexShrink: '0',
            onClick: (e, el, s) => {
              s.root.update({
                selectedClinic: s.clinicName,
                selectedClinicId: s.clinicId,
                activeBookingStep: 2
              })
            }
          }
        },

        ClinicDiscount: {
          show: (el, s) => {
            const discounts = s.root.clinicDiscounts
            return discounts && discounts[s.clinicId]
          },
          flow: 'x',
          gap: 'W',
          align: 'center flex-start',
          padding: 'W Y',
          round: 'Y',
          background: 'teal.15',
          width: 'fit-content',
          DiscountIcon: { extends: 'Icon', icon: 'tag', width: 'Y', height: 'Y', color: 'teal' },
          DiscountText: { text: '{{ specialOfferAvailable | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'teal' }
        }
      }
    }
  }
}
